'use strict';

/**
 * Init Category Switcher Logic
 */
class TWER_CATEGORY_SWITCHER {

  /**
   * Сonstructor
   *
   * @param props
   */
  constructor(props) {

    const i18n_categories = treweler_params.i18n_categories;

    const select2Options = {
      selectionCssClass: 'select2-map-filter-select',
      dropdownCssClass: "select2-map-filter-ddl",
      minimumResultsForSearch: Infinity,
      closeOnSelect: false,
      dropdownParent : jQuery('.select2-map-filter'),
      placeholder: i18n_categories.all,
      language: {
        'noResults': function () {
          return i18n_categories.not_found;
        }
      },
    };
    const $selectMapCat = jQuery('#mapCatField');

    const $parentWidget = $selectMapCat.closest('.twer-widget');
    let ddlShowAbove = false;
    if($parentWidget.hasClass('twer-bottom-right') || $parentWidget.hasClass('twer-bottom-left')) {
      ddlShowAbove = true;
    }

    if(ddlShowAbove) {
      select2Options.dropdownPosition = 'above';
    }

    $selectMapCat.select2(select2Options);

    jQuery('.select2-search.select2-search--inline').html('<span class="category-label">'+i18n_categories.all+'</span>');


    $selectMapCat.on('change', function (e) {
      let inLabel = jQuery('.select2-search .category-label');
      let count = $selectMapCat.select2('data').length;
      let countOptions = jQuery('.select2-results__options .select2-results__option').length;

      if (count === 0) {
        inLabel.html('<span class="category-label">'+i18n_categories.no_selected+'</span>');
      } else if (count === 1) {
        inLabel.html('<span class="category-label">1 '+i18n_categories.one_selected+'</span>');
      } else if (count > 1 && countOptions !== count) {
        inLabel.html('<span class="category-label">' + count + ' '+i18n_categories.selected+'</span>');
      } else {
        inLabel.html('<span class="category-label">'+i18n_categories.all+'</span>');
      }

    });

    let select2Main = jQuery('.select2.select2-container');

    select2Main.has('.select2-dropdown--below').addClass('select2-is-dropdown-below');
    select2Main.has('.select2-dropdown--above').addClass('select2-is-dropdown-above');


    /**
     * Map Category Filter
     */
    $selectMapCat.on('select2:unselecting', (event) => {
      let categoryId = parseInt(event.params.args.data.id) || 0;
      const options = document.getElementById('mapCatField').options;
      const optionsData = {};
      for (let i = 0; i < options.length; i++) {
        if(categoryId === parseInt(options[i].value)) {
          optionsData[options[i].value] = false;
        } else {
          optionsData[options[i].value] = options[i].selected;
        }
      }

      if (TWER.fitBounds) {
        TWER.map.fitBounds(TWER.boundsData, {
          linear: true
        });
      }

      // Run code if clusters disabled
      if(!TWER.allowCluster) {
        for (let i = 0; i < TWER.markers.length; i++) {
          const $markerElement = TWER.markers[i].element._element;
          if ($markerElement.classList.contains(`category-${categoryId}`)) {
            TWER.markers[i].show = false;
            TWER.markers[i].element._element.style.display = 'none';
          }
        }
      } else {
        TWER.globalClusterStatus = false;

        const removedIndexesFeatures = [];
        const removedIndexesMarkers = [];
        const removedCats = [];

        if (!TWER.isEmpty(TWER.clusterData)) {
          if (TWER.clusterData.features.length > 0) {
            for (let i = 0; i < TWER.clusterData.features.length; i++) {
              const props = TWER.clusterData.features[i].properties;
              const categories = JSON.parse(props.cat_ids);

              if(categories.length <= 1) {
                if (categories.includes(categoryId)) {
                  removedCats.push(categoryId);
                  removedIndexesFeatures.push(i);
                  TWER.clusterDataDump.push(TWER.clusterData.features[i]);
                }
              } else {
                let globalApprove = 0;
                for(let j = 0; j < categories.length; j++ ) {
                  if(!optionsData[categories[j]]) {
                    globalApprove++;
                  }
                }

                if(globalApprove === categories.length) {
                  if (categories.includes(categoryId)) {
                    removedCats.push(categoryId);
                    removedIndexesFeatures.push(i);
                    TWER.clusterDataDump.push(TWER.clusterData.features[i]);
                  }
                }
              }


            }

            if(removedIndexesFeatures.length > 0) {
              const indexSet = new Set(removedIndexesFeatures);
              TWER.clusterData.features = TWER.clusterData.features.filter((value, i) => !indexSet.has(i));
            }


            for (let i = 0; i < TWER.markers.length; i++) {
              const props = TWER.markers[i].feature.properties;
              const markerCategories = JSON.parse(props.cat_ids);

              if(markerCategories.length <= 1) {
                if (markerCategories.some(item => removedCats.includes(item))) {
                  removedIndexesMarkers.push(i);
                  TWER.markersDataDump.push(TWER.markers[i]);
                }
              } else {
                let globalApprove1 = 0;
                for(let j = 0; j < markerCategories.length; j++ ) {
                  if(!optionsData[markerCategories[j]]) {
                    globalApprove1++;
                  }
                }

                if(globalApprove1 === markerCategories.length) {
                  if (markerCategories.some(item => removedCats.includes(item))) {
                    removedIndexesMarkers.push(i);
                    TWER.markersDataDump.push(TWER.markers[i]);
                  }
                }

              }
            }

            if(removedIndexesMarkers.length > 0) {

              for (let i = 0; i < removedIndexesMarkers.length; i++) {
                TWER.markers[removedIndexesMarkers[i]].element.remove();
              }

              const indexSet1 = new Set(removedIndexesMarkers);

              TWER.markers = TWER.markers.filter((value, i) => !indexSet1.has(i));

              TWER.map.getSource('locations').setData(TWER.clusterData);
            }

          }
        }


        if(TWER.markersIgnoredClusters.length > 0) {
          for (let i = 0; i < TWER.markersIgnoredClusters.length; i++) {
            const $markerElement = TWER.markersIgnoredClusters[i].element._element;
            if ($markerElement.classList.contains(`category-${categoryId}`)) {
              TWER.markersIgnoredClusters[i].show = false;
              TWER.markersIgnoredClusters[i].element._element.style.display = 'none';
            }
          }
        }
      }

      let lRoutesRaw = event.params.args.data.element.attributes.routes.textContent.split(' ');
      let routeAnyChecked = false;
      let ids = [];

      for (let i = 0; i < lRoutesRaw.length; i++) {
        if (jQuery("#mapCatField option[value!='" + categoryId + "'][routes*='" + lRoutesRaw[i] + "']").is(':checked')) {
          routeAnyChecked = true;
          continue;
        }
        ids.push(lRoutesRaw[i]);
      }

      for (let iw = 0; iw < ids.length; iw++) {
        if (ids[iw] && ids[iw] !== 'route-0') {
          TWER.map.setLayoutProperty(
            ids[iw],
            'visibility',
            'none'
          );
        }
      }

      jQuery('#js-store-locator-radius').trigger('select2:select');
    });


    $selectMapCat.on('select2:select', (event) => {
      let categoryId = parseInt(event.params.data.id) || 0;

      if (TWER.fitBounds) {
        TWER.map.fitBounds(TWER.boundsData, {
          linear: true
        });
      }

      // Run code if clusters disabled
      if(!TWER.allowCluster) {
        for (let i = 0; i < TWER.markers.length; i++) {
          const $markerElement = TWER.markers[i].element._element;
          if ($markerElement.classList.contains(`category-${categoryId}`)) {
            TWER.markers[i].show = true;
            TWER.markers[i].element._element.style.display = 'block';
          }
        }
      } else {


        TWER.globalClusterStatus = false;



        const removedIndexesFeatures = [];
        const removedIndexesMarkers = [];
        const removedCats = [];

        if (!TWER.isEmpty(TWER.clusterDataDump)) {
          if (TWER.clusterDataDump.length > 0) {

            for (let i = 0; i < TWER.clusterDataDump.length; i++) {
              const props = TWER.clusterDataDump[i].properties;
              const categories = JSON.parse(props.cat_ids);
              if (categories.includes(categoryId)) {
                removedCats.push(categoryId);
                removedIndexesFeatures.push(i);
                TWER.clusterData.features.push(TWER.clusterDataDump[i]);
              }
            }

            const indexSet = new Set(removedIndexesFeatures);

            TWER.clusterDataDump = TWER.clusterDataDump.filter((value, i) => !indexSet.has(i));

            for (let i = 0; i < TWER.markersDataDump.length; i++) {
              const props = TWER.markersDataDump[i].feature.properties;
              const markerCategories = JSON.parse(props.cat_ids);
              if (markerCategories.some(item => removedCats.includes(item))) {
                removedIndexesMarkers.push(i);
                TWER.markers.push(TWER.markersDataDump[i]);
              }
            }
            for (let i = 0; i < removedIndexesMarkers.length; i++) {
              const coords = TWER.markersDataDump[removedIndexesMarkers[i]].feature.geometry.coordinates;
              const props = TWER.markersDataDump[removedIndexesMarkers[i]].feature.properties;
              const desc = props?.description;
              props.showPopup = false;
              const markerElement = TWER.createNewMarker(props, coords, desc);

              TWER.markersDataDump[removedIndexesMarkers[i]].element = new TWER_MAPBOX.mapboxgl.Marker(markerElement).setLngLat(coords).addTo(TWER.map);
              TWER.__afterCreateNewMarker(markerElement, props);
            }

            const indexSet1 = new Set(removedIndexesMarkers);

            TWER.markersDataDump = TWER.markersDataDump.filter((value, i) => !indexSet1.has(i));

            TWER.map.getSource('locations').setData(TWER.clusterData);
          }
        }




        if(TWER.markersIgnoredClusters.length > 0) {
          for (let i = 0; i < TWER.markersIgnoredClusters.length; i++) {
            const $markerElement = TWER.markersIgnoredClusters[i].element._element;
            if ($markerElement.classList.contains(`category-${categoryId}`)) {
              TWER.markersIgnoredClusters[i].show = true;
              TWER.markersIgnoredClusters[i].element._element.style.display = 'block';
            }
          }
        }
      }

      let lRoutesRaw = event.params.data.element.attributes.routes.textContent.split(' ');

      for (let i = 0; i < lRoutesRaw.length; i++) {

        if (lRoutesRaw[i] && lRoutesRaw[i] !== 'route-0') {
          TWER.map.setLayoutProperty(
            lRoutesRaw[i],
            'visibility',
            'visible'
          );
        }

      }


      jQuery('#js-store-locator-radius').trigger('select2:select');
    });

  }

}

export default TWER_CATEGORY_SWITCHER;

